<div *ngIf="showItem(setItem(item, header!))">
  <ng-container [ngSwitch]="header!.type">
    <span *ngSwitchDefault style="white-space: pre-wrap">{{
      setItem(item, header!)
    }}</span>

    <span *ngSwitchCase="headerType.Money">{{
      setItem(item, header!) | curr
    }}</span>
    <a
      *ngSwitchCase="headerType.Link"
      routerLink="[]"
      (click)="header?.navigateTo(item)"
      >{{ setItem(item, header!) }}</a
    >
    <span *ngSwitchCase="headerType.Date">{{
      setItem(item, header!) | date
    }}</span>
    <a
      *ngSwitchCase="headerType.Email"
      href="mailto:{{ setItem(item, header!) }}"
      >{{ setItem(item, header!) }}</a
    >
    <span *ngSwitchCase="headerType.StrictValue">{{
      setStrictValue(item, header!)
    }}</span>
    <div *ngSwitchCase="headerType.Array">
      <div *ngFor="let item of item[header!.name]">
        <span>{{ setItemArray(item, header!) }}</span>
        <br />
      </div>
    </div>
    <span *ngSwitchCase="headerType.DamageCause">
      {{ setDamageCause(item) | msg | async }}
    </span>
    <button *ngSwitchCase="headerType.Download" class="btn">
      <svg-icon
        src="../../../assets/images/icons/download.svg"
        [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
      ></svg-icon>
    </button>
  </ng-container>
</div>
<div *ngIf="!showItem(setItem(item, header!))">-</div>
